import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { StoreModule } from '@ngrx/store';
import { FeatureNeededModule } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.module';
import { LoadingSymbolModule } from 'NewAngular/features/components/loaders/loading-symbol/loading-symbol.module';
import { ModalBaseModule } from 'NewAngular/features/components/modals/modal-base/modal-base.module';
import { IconModule } from 'NewAngular/features/directives/icon/icon.module';
import { TooltipModule } from 'NewAngular/features/directives/popovers/tooltip/tooltip.module';
import { IREBAL_PUSH_MODAL_STATE_SLICE_KEY, irebalPushModal } from './irebal-push-modal.store';
import * as i0 from "@angular/core";
import * as i1 from "@ngrx/store";
export class IRebalPushModalModule {
}
IRebalPushModalModule.ɵfac = function IRebalPushModalModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || IRebalPushModalModule)(); };
IRebalPushModalModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: IRebalPushModalModule });
IRebalPushModalModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
        IconModule,
        FormsModule,
        ModalBaseModule,
        FeatureNeededModule,
        LoadingSymbolModule,
        StoreModule.forFeature(IREBAL_PUSH_MODAL_STATE_SLICE_KEY, irebalPushModal),
        TooltipModule] });
